import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import ReactPaginate from "react-paginate";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { useGetJobListMutation } from "../Store/api/JobListApi";
import JobPostComponent from "../Components/Jobs/JobPostComponent";
import {
  useGetCitiesQuery,
  useGetFilterOptionsQuery,
  useGetPageDataQuery,
  useGetSkillsQuery,
} from "../Store/api/CommonApi";

import LoadingJobPostComponent from "../Components/Jobs/LoadingJobPostComponent";
import SelectComponent from "../Components/Common/SelectComponent";

export default function Jobs() {
  const { state } = useLocation();

  const locationRef = useRef();
  const skillsRef = useRef();

  const OptionApi = useGetFilterOptionsQuery();
  const citiesApi = useGetCitiesQuery();
  const skillsApi = useGetSkillsQuery();

  const { data } = useGetPageDataQuery("job-listing");
  const [getJobList, { isLoading }] = useGetJobListMutation();

  const [path, setPath] = useState("");
  const [jobs, setJobs] = useState([]);

  const [jobTypes, setJobTypesOption] = useState({});
  const [experiences, setExperienceOption] = useState({});
  const [postdates, setPostdateOption] = useState({});

  const [totalPages, setTotalPages] = useState(1);

  const [noJobs, setNoJobs] = useState(false);
  const [fetch, setFetch] = useState(true);

  const [cities, setCities] = useState([]);
  const [skills, setSkills] = useState([]);

  const [searchParams] = useSearchParams();

  const page = searchParams.get("page");
  const limit = searchParams.get("limit");
  const keyword = searchParams.get("keyword");
  const location = searchParams.get("location");
  const experience = searchParams.get("experience");
  const skill = searchParams.get("skill");
  const job_types = searchParams.get("job_types");
  const hotjob = searchParams.get("hotjob");
  const postdate = searchParams.get("postdate");

  const [filter, setFilter] = useState({
    page: page ? page : 1,
    limit: limit ? limit : "10",
    keyword: keyword ? keyword : "",
    location: location ? location : "",
    experience: experience ? experience : "",
    skill: skill ? skill : "",
    job_types: job_types ? job_types : "",
    hotjob: hotjob ? hotjob : "",
    postdate: postdate ? postdate : "",
  });

  const handleGetJobList = useCallback(
    (filter) => {
      setNoJobs(false);
      getJobList(filter)
        .then((res) => {
          if (res?.error !== undefined) {
            setNoJobs(true);
            setJobs([]);
            setPath("");
            setTotalPages(0);
          } else {
            setJobs(res.data?.data);
            setPath(res.data?.path);
            setTotalPages(res.data?.totalPages);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    [getJobList, setJobs, setPath, setTotalPages, setNoJobs]
  );

  useEffect(() => {
    if (fetch) {
      handleGetJobList(filter);
      window.scrollTo(0, 150);
    }
  }, [handleGetJobList, fetch, filter]);

  const onApplyFilter = useCallback(() => {
    let experience = window.$('input[name="experience"]:checked').val();
    let postdate = window.$('input[name="postdate"]:checked').val();

    let filterData = {
      ...filter,
      experience: experience,
      postdate: postdate,
    };
    setFilter(filterData);
    setFetch(true);
  }, [setFetch, setFilter, filter]);

  useEffect(() => {
    if (OptionApi?.data) {
      setJobTypesOption(OptionApi?.data?.data?.job_types);
      setExperienceOption(OptionApi?.data?.data?.experience);
      setPostdateOption(OptionApi?.data?.data?.postdate);
    }
  }, [
    OptionApi?.data,
    setJobTypesOption,
    setExperienceOption,
    setPostdateOption,
  ]);

  const formatOptionList = useCallback((res, label, value, callback) => {
    if (res.length > 0) {
      let optionArray = [];
      res.forEach((obj, i) => {
        optionArray.push({ value: obj[value], label: obj[label] });
      });
      callback(optionArray);
    }
  }, []);

  useEffect(() => {
    if (citiesApi?.data) {
      formatOptionList(citiesApi?.data?.data, "city_name", "id", setCities);
    }
  }, [citiesApi, setCities, formatOptionList]);

  useEffect(() => {
    if (skillsApi?.data) {
      formatOptionList(skillsApi?.data?.data, "skill_title", "id", setSkills);
    }
  }, [skillsApi, setSkills, formatOptionList]);

  const onCheckTypes = useCallback(() => {
    let checkedArray = [];
    window.$.each(window.$(".job-type"), function (i, element) {
      if (window.$(element).is(":checked")) {
        checkedArray.push(window.$(element).val());
      }
    });

    let filterdata = { ...filter, job_types: checkedArray.toString() };

    setFilter(filterdata);
    setFetch(true);
  }, [setFilter, filter, setFetch]);

  const onReset = useCallback(() => {
    window.$(".job-type").prop("checked", false);
    window.$('input[name="postdate"]').prop("checked", false);
    window.$('input[name="experience"]').prop("checked", false);

    if (skillsRef.current) skillsRef.current.clearValue();
    if (locationRef.current) locationRef.current.clearValue();

    let fileterData = {
      page: 1,
      limit: "10",
      keyword: "",
      location: "",
      experience: "",
      skill: "",
      job_types: "",
      hotjob: "",
      postdate: "",
    };

    setFilter(fileterData);
    setFetch(true);
  }, [setFilter, setFetch]);

  const onPageChange = useCallback(
    (number) => {
      let filterdata = {
        ...filter,
        page: number,
      };
      setFilter(filterdata);
      setFetch(true);
    },
    [setFilter, filter, setFetch]
  );

  const createPaginationLink = useCallback(
    (number) => {
      let paging = [];
      for (let index = 1; index <= number; index++) {
        paging.push(
          <li
            className={`page-item ${filter?.page === index ? "active" : ""}`}
            key={index}
          >
            <Link
              className="page-link"
              to="#"
              onClick={() => onPageChange(index)}
            >
              {index}
            </Link>
          </li>
        );
      }
      return paging;
    },
    [onPageChange, filter]
  );

  useEffect(() => {
    if (state) {
      onReset();
    }
  }, [onReset, state]);

  const onFilterChange = useCallback(
    (key, value) => {
      onApplyFilter();
    },
    [onApplyFilter]
  );

  const handleSelect = useCallback(
    (values, inputname) => {
      if (values?.length > 0) {
        let ids = [];
        values.forEach((element, i) => {
          ids.push(element?.value);
        });
        setFilter({ ...filter, [inputname]: ids.toString() });
      } else if (values?.value) {
        setFilter({ ...filter, [inputname]: values.value.toString() });
      } else {
        setFilter({ ...filter, [inputname]: "" });
      }
    },
    [filter, setFilter]
  );

  return (
    <Fragment>
      <PageBannerComponent
        title={data?.data?.heading}
        image={data?.data?.image}
      />

      {data?.data?.content !== "" && (
        <div className="container mt-4">
          <p dangerouslySetInnerHTML={{ __html: data?.data?.content }}></p>
        </div>
      )}

      {/* Start post Area */}
      <section className="post-area section-gap">
        <div className="container">
          <div className="row justify-content-center d-flex">
            <div className="col-lg-3 sidebar">
              <div className="single-element-widget mt-30">
                <h4 className="mb-30">
                  Job Category &nbsp; &nbsp; &nbsp;
                  <Link
                    to=""
                    style={{
                      fontWeight: "normal",
                      fontSize: 15,
                      color: "grey",
                    }}
                    onClick={() => onReset({})}
                  >
                    Reset All
                  </Link>
                </h4>
                <SelectComponent
                  create={false}
                  multiple={true}
                  options={skills}
                  selectRef={skillsRef}
                  //selected={[{ value: filter?.skill, label: "Sales" }]}
                  name="skill"
                  onValueSelect={handleSelect}
                />
                {/* <div className="default-select" id="default-select">
                  <select
                    id="skills"
                    className="form-control"
                    defaultValue={filter?.skill}
                    onChange={(e) => onFilterChange("skill", e.target.value)}
                  >
                    <option value="">Select Skills</option>
                    {skills}
                  </select>
                </div> */}
              </div>
              <div className="single-element-widget mt-50">
                <h4 className="mb-30">Employment</h4>
                {Object.keys(jobTypes).length > 0 &&
                  Object.keys(jobTypes).map((type, i) => {
                    return (
                      <div
                        className="switch-wrap d-flex justify-content-between"
                        key={i}
                      >
                        <p>{jobTypes[type]}</p>
                        <div className="primary-checkbox">
                          <input
                            type="checkbox"
                            className="job-type"
                            value={type}
                            id={`default-type-${type}`}
                            onChange={onCheckTypes}
                          />
                          <label htmlFor={`default-type-${type}`} />
                        </div>
                      </div>
                    );
                  })}

                {/* <div className="switch-wrap d-flex justify-content-between">
                  <p>Full Time</p>
                  <div className="primary-checkbox">
                    <input type="checkbox" id="default-checkbox" />
                    <label htmlFor="default-checkbox" />
                  </div>
                </div>
                <div className="switch-wrap d-flex justify-content-between">
                  <p>Part Time</p>
                  <div className="primary-checkbox">
                    <input
                      type="checkbox"
                      id="primary-checkbox"
                      defaultChecked={true}
                    />
                    <label htmlFor="primary-checkbox" />
                  </div>
                </div>
                <div className="switch-wrap d-flex justify-content-between">
                  <p>Remote</p>
                  <div className="confirm-checkbox">
                    <input type="checkbox" id="confirm-checkbox" />
                    <label htmlFor="confirm-checkbox" />
                  </div>
                </div>
                <div className="switch-wrap d-flex justify-content-between">
                  <p>Freelancer</p>
                  <div className="disabled-checkbox">
                    <input type="checkbox" id="disabled-checkbox" disabled="" />
                    <label htmlFor="disabled-checkbox" />
                  </div>
                </div>
                <div className="switch-wrap d-flex justify-content-between">
                  <p>Hybrid</p>
                  <div className="disabled-checkbox">
                    <input
                      type="checkbox"
                      id="disabled-checkbox-active"
                      defaultChecked=""
                      disabled=""
                    />
                    <label htmlFor="disabled-checkbox-active" />
                  </div>
                </div> */}
              </div>
              <div className="single-element-widget mt-50">
                <h4 className="mb-30">Job Location</h4>
                <div className="default-select" id="default-select">
                  <SelectComponent
                    create={false}
                    multiple={true}
                    options={cities}
                    selectRef={locationRef}
                    name="location"
                    onValueSelect={handleSelect}
                  />
                  {/* <select
                    className="form-control"
                    id="location"
                    defaultValue={filter?.location}
                    onChange={(e) => onFilterChange("location", e.target.value)}
                  >
                    <option value="">All Location</option>
                    {cities}
                  </select> */}
                </div>
              </div>
              <div className="single-element-widget mt-50">
                <h4 className="mb-30">Experience</h4>
                {Object.keys(experiences).length > 0 &&
                  Object.keys(experiences).map((exp, i) => {
                    return (
                      <div
                        className="switch-wrap d-flex justify-content-between"
                        key={i}
                      >
                        <p>{experiences[exp]}</p>
                        <div className="primary-radio">
                          <input
                            type="radio"
                            name="experience"
                            id={`default-checkbox-${exp}`}
                            value={exp}
                            defaultChecked={
                              filter?.experience === exp ? true : false
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                onFilterChange("experience", e.target.value);
                              } else {
                                onFilterChange("experience", "");
                              }
                            }}
                          />
                          <label htmlFor={`default-checkbox-${exp}`} />
                        </div>
                      </div>
                    );
                  })}
                {/* <div className="switch-wrap d-flex justify-content-between">
                  <p>0 - 2 years</p>
                  <div className="disabled-checkbox">
                    <input
                      type="checkbox"
                      id="disabled-checkbox-active"
                      defaultChecked=""
                      disabled=""
                    />
                    <label htmlFor="disabled-checkbox-active" />
                  </div>
                </div>
                <div className="switch-wrap d-flex justify-content-between">
                  <p>2 - 5 years</p>
                  <div className="primary-checkbox">
                    <input type="checkbox" id="default-checkbox" />
                    <label htmlFor="default-checkbox" />
                  </div>
                </div>
                <div className="switch-wrap d-flex justify-content-between">
                  <p>6 - 8 years</p>
                  <div className="primary-checkbox">
                    <input
                      type="checkbox"
                      id="primary-checkbox"
                      defaultChecked=""
                    />
                    <label htmlFor="primary-checkbox" />
                  </div>
                </div>
                <div className="switch-wrap d-flex justify-content-between">
                  <p>9 - 11 years</p>
                  <div className="confirm-checkbox">
                    <input type="checkbox" id="confirm-checkbox" />
                    <label htmlFor="confirm-checkbox" />
                  </div>
                </div>
                <div className="switch-wrap d-flex justify-content-between">
                  <p>12 - 20 years</p>
                  <div className="disabled-checkbox">
                    <input type="checkbox" id="disabled-checkbox" disabled="" />
                    <label htmlFor="disabled-checkbox" />
                  </div>
                </div>
                <div className="switch-wrap d-flex justify-content-between">
                  <p>Above 20 years</p>
                  <div className="disabled-checkbox">
                    <input type="checkbox" id="disabled-checkbox" disabled="" />
                    <label htmlFor="disabled-checkbox" />
                  </div>
                </div> */}
              </div>
              <div className="single-element-widget mt-50">
                <h4 className="mb-30">Posted Within</h4>
                {Object.keys(postdates).length > 0 &&
                  Object.keys(postdates).map((dts, i) => {
                    return (
                      <div
                        className="switch-wrap d-flex justify-content-between"
                        key={i}
                      >
                        <p>{postdates[dts]}</p>
                        <div className="primary-radio">
                          <input
                            type="radio"
                            name="postdate"
                            id={`default-post-date-${dts}`}
                            value={dts}
                            onChange={(e) => {
                              if (e.target.checked) {
                                onFilterChange("postdate", e.target.value);
                              } else {
                                onFilterChange("postdate", "");
                              }
                            }}
                          />
                          <label htmlFor={`default-post-date-${dts}`} />
                        </div>
                      </div>
                    );
                  })}
                {/* <div className="switch-wrap d-flex justify-content-between">
                  <p>Any</p>
                  <div className="disabled-checkbox">
                    <input
                      type="checkbox"
                      id="disabled-checkbox-active"
                      defaultChecked=""
                      disabled=""
                    />
                    <label htmlFor="disabled-checkbox-active" />
                  </div>
                </div>
                <div className="switch-wrap d-flex justify-content-between">
                  <p>Today</p>
                  <div className="primary-checkbox">
                    <input type="checkbox" id="default-checkbox" />
                    <label htmlFor="default-checkbox" />
                  </div>
                </div>
                <div className="switch-wrap d-flex justify-content-between">
                  <p>Last 2 days</p>
                  <div className="primary-checkbox">
                    <input
                      type="checkbox"
                      id="primary-checkbox"
                      defaultChecked=""
                    />
                    <label htmlFor="primary-checkbox" />
                  </div>
                </div>
                <div className="switch-wrap d-flex justify-content-between">
                  <p>Last 3 days</p>
                  <div className="confirm-checkbox">
                    <input type="checkbox" id="confirm-checkbox" />
                    <label htmlFor="confirm-checkbox" />
                  </div>
                </div>
                <div className="switch-wrap d-flex justify-content-between">
                  <p>Last 10 days</p>
                  <div className="disabled-checkbox">
                    <input type="checkbox" id="disabled-checkbox" disabled="" />
                    <label htmlFor="disabled-checkbox" />
                  </div>
                </div>
                <div className="switch-wrap d-flex justify-content-between">
                  <p>Last 30 days</p>
                  <div className="disabled-checkbox">
                    <input type="checkbox" id="disabled-checkbox" disabled="" />
                    <label htmlFor="disabled-checkbox" />
                  </div>
                </div> */}
              </div>
              {/*<button
                onClick={onApplyFilter}
                type="button"
                className="btn btn-primary btn-block mt-4"
              >
                Apply Filter
              </button>*/}
            </div>
            <div className="col-lg-9 post-list d-flex flex-column">
              {jobs?.length > 0 &&
                !isLoading &&
                jobs.map((job, i) => {
                  return <JobPostComponent item={job} key={i} path={path} />;
                })}
              {noJobs && (
                <Fragment>
                  <div className="single-post text-center">
                    <h6>
                      No jobs found matching your search. Please check back
                      later or explore other opportunities.
                    </h6>
                  </div>
                </Fragment>
              )}
              {isLoading && (
                <Fragment>
                  <LoadingJobPostComponent />
                  <LoadingJobPostComponent />
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </section>
      {/* End post Area */}
      {/*Pagination Start  */}
      <div className="pagination-area text-center mb-50">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="single-wrap d-flex justify-content-center">
                <nav aria-label="Page navigation example">
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={({ selected }) => onPageChange(selected + 1)}
                    pageRangeDisplayed={5}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName="pagination justify-content-start"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    activeClassName="active"
                    previousClassName="page-link"
                    nextClassName="page-link"
                    breakClassName="page-link"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*Pagination End  */}
      {/* Start callto-action Area */}
      <section className="callto-action-area section-gap">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="menu-content col-lg-9">
              <div className="title text-center">
                <p className="text-white">FEATURED TOURS PACKAGES</p>
                <h1 className="mb-10 text-white">
                  Make a Difference with Your Online Resume!
                </h1>
                <Link className="primary-btn" to="/login">
                  Upload your CV
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End calto-action Area */}
    </Fragment>
  );
}
